import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThumbUpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thumb_up"}/>
}
